module.exports = __webpack_public_path__ + "static/media/inorc_light_bg.56d51333.jpg";